import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoToMp3ConverterConfig } from '@/data/landingConfig/landingVideoToMp3ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoToMp3Converter } from './schemaObject';

interface Props {}
const VideoToMp3Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoToMp3Converter} />
			<VideoLandingTemplate
				data={landingVideoToMp3ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default VideoToMp3Converter;
